import { isActiveCoachMemoryNode } from "@/lib/leaderMemoryVisibility";
import type {
  CoachLensSource,
  CoachMemorySource,
  CoachTwinSource,
} from "@/lib/coachSessionReviewContract";

export function extractCoachTwinSource(twinJson: unknown): CoachTwinSource | null {
  if (!twinJson || typeof twinJson !== "object") return null;
  const twin = twinJson as Record<string, unknown>;
  const result = {
    voice_summary: typeof twin.voice_summary === "string" ? twin.voice_summary : null,
    question_stems: Array.isArray(twin.question_stems) ? twin.question_stems.filter((item): item is string => typeof item === "string") : null,
    phrase_bank: Array.isArray(twin.phrase_bank) ? twin.phrase_bank.filter((item): item is string => typeof item === "string") : null,
    avoid_list: Array.isArray(twin.avoid_list) ? twin.avoid_list.filter((item): item is string => typeof item === "string") : null,
    guardrails: Array.isArray(twin.guardrails) ? twin.guardrails.filter((item): item is string => typeof item === "string") : null,
    identity_template_preview: twin.identity_template_preview && typeof twin.identity_template_preview === "object"
      ? twin.identity_template_preview as CoachTwinSource["identity_template_preview"]
      : null,
  } satisfies CoachTwinSource;
  const hasContent = Boolean(
    result.voice_summary
    || result.question_stems?.length
    || result.phrase_bank?.length
    || result.avoid_list?.length
    || result.guardrails?.length
  );
  return hasContent ? result : null;
}

export function buildCoachMemorySource(
  rows: Array<{ node_type?: string | null; title?: string | null; content?: string | null }> | null | undefined,
): CoachMemorySource | null {
  const activeRows = rows?.filter(isActiveCoachMemoryNode) ?? [];
  if (activeRows.length === 0) return null;
  return {
    nodeCounts: activeRows.reduce<Record<string, number>>((acc, row) => {
      const key = row.node_type || "unknown";
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    }, {}),
    recentNodes: activeRows,
  } satisfies CoachMemorySource;
}

export function coerceCoachLensSource(value: CoachLensSource | null | undefined): CoachLensSource | null {
  return value || null;
}
